module.exports = __webpack_public_path__ + "static/media/07-01.66edd2cd.png";